"use strict";

exports.__esModule = true;
exports.getTooltipValueFormatter = exports.getTooltipIconStyles = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _constants = require("../constants");
var _timeAggregationBinMapping = require("../../VIMANAMetrics/timeAggregationBinMapping");
var _getValueFormatter = require("../Utils/getValueFormatter");
var _constants2 = require("../../constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getTooltipIconStyles = exports.getTooltipIconStyles = function getTooltipIconStyles(chartType) {
  if (chartType === _constants.LINE_CHART) {
    return {
      height: "2px",
      borderRadius: "0px"
    };
  } else if (chartType === _constants.SCATTER_CHART) {
    return {
      height: "10px",
      borderRadius: "5px"
    };
  } else {
    return {};
  }
};

/**
 *  Value format for tooltip is different than that of axis.
 *  For Eg.
 *   For Hour Agg.     - 12:00, 12 Dec 2020
 *       Tick Value    = 12:00
 *       Tooltip Value = 2020-12-12 12:00
 * */
var getTooltipValueFormatter = exports.getTooltipValueFormatter = function getTooltipValueFormatter(type, timezoneName) {
  if (!type) {
    return function (value) {
      return _momentTimezone["default"].utc(value).format(_constants.TIMESTAMP_FORMAT);
    };
  } else {
    if (type === _timeAggregationBinMapping.HOUR_PER_DAY) {
      return function (value) {
        return _momentTimezone["default"].utc(value).tz(timezoneName).format("YYYY-MM-DD HH:mm");
      };
    } else if (type === _constants2.METRICS_FRACTIONAL_PERCENT) {
      return function (value) {
        return fixTillTwoDigits(value * 100) + "%";
      };
    }
    return (0, _getValueFormatter.getValueFormatter)(type, timezoneName);
  }
};
var fixTillTwoDigits = function fixTillTwoDigits(value) {
  return parseFloat(value).toFixed(2);
};